import { render, staticRenderFns } from "./DeviceHistoryForm.vue?vue&type=template&id=5ac24103&"
import script from "./DeviceHistoryForm.vue?vue&type=script&lang=ts&"
export * from "./DeviceHistoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports